__turbopack_context__.v({
  "tabs": "cA0BtG_tabs",
  "tabs__nav": "cA0BtG_tabs__nav",
  "tabs__panel": "cA0BtG_tabs__panel",
});
